/* eslint-disable react/react-in-jsx-scope */
import { useTranslation } from "react-i18next";

const OfferAdBanner = () => {
  const { t } = useTranslation();
  return (
    <div
      className="z-20 hidden h-8 items-center  text-white lg:flex"
      style={{
        backgroundColor: "#ff3333",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "15%",
      }}
    >
      <div
        className="container"
        style={{
          padding: "0.5rem 15px",
        }}
      >
        <nav className="grid items-center gap-4">
          <h5
            className="text-center text-sm text-primary-50"
            style={{
              fontSize: "14px",
              lineHeight: "20px",
              textAlign: "center",
              fontWeight: "bold",
            }}
          >
            {t("errorTextForStoreOffline") || "Get 50% off on your first order"}
          </h5>
        </nav>
      </div>
    </div>
  );
};

export default OfferAdBanner;
